var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-info round",attrs:{"to":"/dashboard"}},[_vm._v("\n  "+_vm._s(_vm.$t('back_to_dashboard'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }